<template>
  <div class="app bg-gray" v-if="showAddVoucherArea">
    <scroll @refresh="loadVouchers" style="background: #f0f1f5">
      <div
        v-show="showAddVoucherArea"
        class="flex-row flex-align-center add-voucher-area"
        @click="addVoucher"
      >
        <div class="add-voucher-icon"></div>
        <div class="flex-1 flex-width">
          暂无就诊凭证，请<span class="f-strong">先绑定就诊凭证</span>
        </div>
      </div>
    </scroll>
  </div>
  <div class="app bg-gray" id="register-registConfirm" v-else>
    <div
      class="bg-white"
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.3rem;
      "
    >
      <span>选择就诊凭证查看居民健康档案</span>
      <button v-show="showAddVoucherBtn" class="btn-ugly" @click="addVoucher">
        +添加家庭成员
      </button>
    </div>
    <!-- 就诊凭证列表 -->
    <scroll
      class="to-bottom-btn"
      @refresh="loadVouchers"
      style="top: 1.6rem; background: #fff"
    >
      <div
        v-show="showAddVoucherArea"
        class="flex-row flex-align-center add-voucher-area"
        @click="addVoucher"
      >
        <div class="add-voucher-icon"></div>
        <div class="flex-1 flex-width">
          暂无就诊凭证，请<span class="f-strong">先绑定就诊凭证</span>
        </div>
      </div>
      <voucher-item-small
        v-for="(voucher, index) in vouchers"
        :key="index"
        :voucher="voucher"
        :index="index"
        :class="selectedIndex == index ? 'selected' : 'disabled'"
        @selected="selectVoucher"
      ></voucher-item-small>
      <div class="register-des">
        <h5 class="reminder">温馨提示</h5>
        <p>1.您可通过添加家庭成员查询家人健康档案。</p>
      </div>
    </scroll>
    <footer>
      <button
        class="btn-complete"
        type="button"
        @click="goSendVerifyCodePage"
        style="border-radius: 0"
      >
        确认
      </button>
    </footer>
  </div>
</template>
<script>
import VoucherItemSmall from '../voucher/VoucherItemSmall'
import voucherService from 'voucher.service'
import utils from 'utils'
export default {
  components: {
    VoucherItemSmall,
  },
  mounted () {
    this.loadVouchers();
  },

  data () {
    return {
      vouchers: [],
      selectedIndex: 0,
      selectedVoucher: {},
      showAddVoucherArea: false,
      showMessageConfirm: false,
      showPayConfirm: false,
    }
  },
  computed: {
    showAddVoucherBtn () {
      return this.vouchers.length > 0 && this.vouchers.length < 3;
    },
  },
  methods: {
    loadVouchers: function () {
      voucherService.getVoucherList().then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }
        this.vouchers = res.data || [];
        if (this.vouchers.length === 0) {
          this.showAddVoucherArea = true;
          return;
        }
        this.showAddVoucherArea = false;
        //默认第一张诊疗卡
        this.selectedIndex = 0;
        this.selectedVoucher = this.vouchers[0];
      })
    },
    selectVoucher (voucher, index) {
      this.selectedIndex = index;
      this.selectedVoucher = voucher;
    },
    goSendVerifyCodePage: function () {
      if (!this.selectedVoucher.cardNo) {
        return utils.alert('请先添加诊疗卡');
      }
      // 跳转到发送验证码页面
      this.$store.commit('updateParam', {
        namespace: 'residentHealthRecordCode',
        selectedVoucher: JSON.stringify(this.selectedVoucher)
      });
      this.$router.push({
        path: 'residentHealthRecordCode'
      });
    },
    addVoucher: function () {
      this.$router.push({
        path: 'voucherChooseType'
      });
    },
  }
}
</script>
<style lang="scss">
@import "../../../static/sass/_variable.scss";

.add-voucher-area {
  margin: 15rem 0.2rem 0;
  padding: 1rem 0.5rem;
  border: 1px dotted $main-style-color;
  background: #fff;
  .add-voucher-icon {
    height: 3rem;
    width: 2.5rem;
    margin-right: 0.5rem;
    background: url("../../../static/img/voucher-add.png") center no-repeat;
    background-size: contain;
  }
}
.register-des {
  color: #f24141;
  background: #eff2f5;
  margin: 0.5rem 0.5rem;
  padding: 0.2rem;
  .reminder {
    width: 4rem;
    background: url("../../../static/img/reminder.png") center left no-repeat;
    background-size: 17px 17px;
    padding-left: 1rem;
  }
  p {
    padding-left: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// VoucherSelect.vue?204e5b62